import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MultimediaManagerDialogItem } from '../../multimedia-manager/multimedia-manager-dialog/multimedia-manager-dialog-item.model';

@Component({
  selector: 'app-photo-editor',
  templateUrl: './photo-editor.component.html',
  styleUrls: ['./photo-editor.component.scss']
})
export class PhotoEditorComponent implements OnInit {

  @Input() source: MultimediaManagerDialogItem;
  @Output() result = new EventEmitter<any>();

  constructor() { }

  ngOnInit() { }

  public resultReceiver(result) {
    this.result.emit(result);
  }
}
